export default __webpack_public_path__ + "static/media/105.bc3e0d6c.png";